import { LangCodeEnum } from 'shared/enums/LangCodeEnum';
import { EmailTemplateModel } from 'api/dto/EmailTemplate.dto';

export type EmailTemplateFormValues = {
  language: LangCodeEnum;
  emailTemplate: EmailTemplateModel;
};

export type EmailTemplateTranslation = {
  locale: LangCodeEnum;
  title: string;
  content: string;
  htmlContent: string;
};

export const mapEmailTemplateFormValuesToTranslations = ({
  language,
  emailTemplate,
}: {
  language: LangCodeEnum;
  emailTemplate: EmailTemplateModel;
}): EmailTemplateTranslation => {
  const result = {
    locale: language,
    title: emailTemplate.title,
    content: JSON.stringify(emailTemplate.content),
    htmlContent: EmailTemplateModel.getHtmlContent(emailTemplate),
  };

  return result;
};
